import { observable, runInAction } from 'mobx';
import { partnerInsurancesController } from './partnerInsurancesController';
import {
  CreatePartnerInsuranceBindingRequest,
  PartnerInsuranceBindingView,
  UpdatePartnerInsuranceBindingRequest,
  PartnerInsuranceByOfficeAndServiceItem,
  PartnerInsuranceByOfficeAndServiceRequest,
} from './partnerInsurancesApi';

export interface PartnerInsurancesStore {
  partnerInsuranceBindings: PartnerInsuranceBindingView[],

  partnerInsuranceByOfficeAndService: PartnerInsuranceByOfficeAndServiceItem[],
  partnerInsuranceByOfficeAndServiceRequest: PartnerInsuranceByOfficeAndServiceRequest,

  error: string,
}

const initialValues: PartnerInsurancesStore = {
  partnerInsuranceBindings: [],

  partnerInsuranceByOfficeAndService: [],
  partnerInsuranceByOfficeAndServiceRequest: null,
  error: null,
};

export const partnerInsurancesStore = observable(initialValues);

export const partnerInsurancesActions = {
  handleError: (error: string) => {
    partnerInsurancesStore.error = error;
  },

  async createPartnerInsuranceBinding(data: CreatePartnerInsuranceBindingRequest) {
    try {
      await partnerInsurancesController.createPartnerInsuranceBinding(data);
    } catch (err) {
      this.handleError(err);
    }
  },
  async updatePartnerInsuranceBinding(id: string, data: UpdatePartnerInsuranceBindingRequest) {
    try {
      await partnerInsurancesController.updatePartnerInsuranceBinding(id, data);
    } catch (err) {
      this.handleError(err);
    }
  },
  async getPartnerInsuranceBindingsByPartnerId(partnerId: string) {
    try {
      const response = await partnerInsurancesController.getPartnerInsuranceBindingsByPartnerId(partnerId);
      runInAction(() => {
        partnerInsurancesStore.partnerInsuranceBindings = response.data;
      });
    } catch (err) {
      this.handleError(err);
    }
  },
  async deletePartnerInsuranceBinding(id: string) {
    try {
      await partnerInsurancesController.deletePartnerInsuranceBinding(id);
    } catch (err) {
      this.handleError(err);
    }
  },

  async getPartnerInsuranceByOfficeAndService(request: PartnerInsuranceByOfficeAndServiceRequest) {
    try {
      runInAction(() => {
        partnerInsurancesStore.partnerInsuranceByOfficeAndServiceRequest = request;
      });
      const response = await partnerInsurancesController.getPartnerInsuranceByOfficeAndService(request);
      runInAction(() => {
        partnerInsurancesStore.partnerInsuranceByOfficeAndService = response.data?.items ?? [];
      });
    } catch (err) {
      partnerInsurancesActions.clearPartnerInsuranceByOfficeAndService();
      this.handleError(err);
    }
  },

  async clearPartnerInsuranceByOfficeAndService() {
    try {
      runInAction(() => {
        partnerInsurancesStore.partnerInsuranceByOfficeAndService = [];
        partnerInsurancesStore.partnerInsuranceByOfficeAndServiceRequest = null;
      });
    } catch (err) {
      this.handleError(err);
    }
  },
};
